import { http } from "./http";

export async function solicitarCodigo(emailOuUsuario) {
  const url = `${process.env.REACT_APP_SERVER}/password-reset/request`;
  return http(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ identifier: emailOuUsuario }),
  });
}

export async function verificarCodigo(emailOuUsuario, codigo) {
  const url = `${process.env.REACT_APP_SERVER}/password-reset/verify`;
  return http(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ identifier: emailOuUsuario, code: codigo }),
  });
}

export async function redefinirSenha(emailOuUsuario, codigo, novaSenha) {
  const url = `${process.env.REACT_APP_SERVER}/password-reset/reset`;
  return http(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ identifier: emailOuUsuario, code: codigo, newPassword: novaSenha }),
  });
}
